/**
 * Williams %R
 *
 * Momentum oscillator (range −0 to −100).
 * Measures overbought/oversold levels.  Values near 0 are overbought;
 * near −100 are oversold.
 * Default period: 14.
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";

export const williamsRIndicator: IndicatorDefinition = {
  id: "willr",
  name: "Williams %R",
  shortName: "Will%R",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 14, min: 1, max: 200 },
    { key: "color", label: "Color", type: "color", default: "#E040FB" },
  ],
  plots: [
    { key: "willr", label: "%R", color: "#E040FB", style: "line", lineWidth: 2, priceScaleId: "willr" },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const data: { time: number; value: number }[] = [];

    for (let i = period - 1; i < candles.length; i++) {
      let highest = -Infinity, lowest = Infinity;
      for (let j = i - period + 1; j <= i; j++) {
        highest = Math.max(highest, candles[j].high);
        lowest = Math.min(lowest, candles[j].low);
      }
      const range = highest - lowest;
      const wr = range === 0 ? -50 : ((highest - candles[i].close) / range) * -100;
      data.push({ time: candles[i].time, value: wr });
    }

    return [{ key: "willr", data }];
  },
};
